/* eslint-disable eqeqeq */
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NbPopoverDirective, NbToastrService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { mongoId } from '../../../@core/common/global';
import { SidebarCommon } from '../../../@core/common/sidebar';
import { ApiService } from '../../../@core/service/api.service';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { BusinessModel, UserModel } from '../../../@models';
import { BaseProductModel } from '../../../@models/erp/baseProduct';
import { Currency, IssuerData, UnitData } from '../../../@models/erp/compilationData';
import { EFinishedProductStatus, EProductType, FinishedProductModel, NameTable } from '../../../@models/erp/finishedProduct';
import { PriceMatrixModel, EAccountingType, PriceItem } from '../../../@models/erp/priceMatrix';
import { FormListComponent } from '../../shared';
import { FormListDateEditComponent } from '../../shared/form-list/renderer/form-list-date-edit.component';
import { FormListDateRendererComponent } from '../../shared/form-list/renderer/form-list-date-renderer.component';
import { EWizardAction, ProductWizardComponent, WizardAction } from '../product-wizard/product-wizard.component';
import * as moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';
import { UnitSelectorRendererComponent } from './unit-selector-renderer/unit-selector-renderer.component';
import { NrkWindowComponent } from '../shared/nrk-window/nrk-window.component';

@Pipe({name: 'mergeCellStyle', pure: true})
export class MergeCellStylePipe implements PipeTransform {
  transform(colStyle: any, col: any): any {
    const base = colStyle || {};
    const textAlign = base['text-align'] ?? (col && col.num ? 'right' : null);
    return Object.assign({}, base, { 'text-align': textAlign, 'max-width': null });
  }
}

@Component({
    selector: 'ngx-erp-price-matrix',
    templateUrl: './price-matrix.component.html',
    styleUrls: ['./price-matrix.component.scss']
})
export class PriceMatrixComponent extends SidebarCommon<PriceMatrixModel> implements OnInit, OnDestroy, OnChanges {

  @Input() fromWizard: ProductWizardComponent = null;
  @Input() finishedProduct: FinishedProductModel;
  @Input() issuer: number;
  @Output() wizardAction = new EventEmitter<WizardAction>()

  @ViewChild('formListSell') formListSell: FormListComponent;
  @ViewChild('formListPurchase') formListPurchase: FormListComponent;

  priceMatrix: PriceMatrixModel[] = [];
  businesses: BusinessModel[] = [];
  // finishedProductNames: NameTable[] = [];
  baseProducts: BaseProductModel[] = [];
  baseProduct: BaseProductModel;
  baseProductCode: string;
  baseProductOptions: { id: string, name: string }[];
  finishedProducts: FinishedProductModel[] = [];
  finishedProductsForComparison: FinishedProductModel[] = [];
  businessOptions: { id: string, name: string}[] = [];
  customerOptions: { id: string, name: string }[] = [];
  supplierOptions: { id: string, name: string }[] = [];
  unitOptions = UnitData.getShortOptions();
  currOptions = Currency.getOptions();

  displayMode: string;
  // issuer: number;

  // activeRow = null;
  
  mongoId = mongoId; // forward to template

  productPrice = {
    sale: {
      matrix: null, // PriceMatrixModel
      business: null, // BusinessModel
      files: [],
    },
    purchase: {
      matrix: null, // PriceMatrixModel
      business: null, // BusinessModel
      files: [],
    },
    finishedProduct: null, // FinishedProductModel
  }
  salesTable = null;
  purchaseTable = null;

  sellingPrice = {
    title: 'Selling price matrix',
    business: null,
    businesses: null,
    businessUnit: null,
    accounting: EAccountingType.Sale,
    rowData: [],
  }

  buyingPrice = {
    title: 'Buying price matrix',
    business: null,
    businesses: null,
    businessUnit: null,
    accounting: EAccountingType.Purchase,
    rowData: [],
  }

  accountingPrices = [this.sellingPrice, this.buyingPrice];

  priceTypeOptions: { value: string, title: string }[] = [];
  currencyOptions: { value: string, title: string }[] = [];

  currentRows = [];

  getPriceColumns: any = (acc) => ({
    validFrom: {
      title: 'Valid from',
      type: 'custom',
      renderComponent: FormListDateRendererComponent,
      filter: false,
      defaultValue: new Date().toISOString(),
      editor: {
        type: 'custom',
        component: FormListDateEditComponent,
        config: {
          acc: acc,
          callback: (instances: FormListDateEditComponent[], instance: FormListDateEditComponent, oldValue, newValue) => {
            console.log('callback', instances, instance, oldValue, newValue);
            this.onDateFrom(instances, instance, oldValue, newValue);
          }
        }
      },
    },
    validTo: {
      title: 'Valid to',
      type: 'custom',
      renderComponent: FormListDateRendererComponent,
      filter: false,
      defaultValue: undefined,
      editor: {
        type: 'custom',
        component: FormListDateEditComponent,
        config: {
          acc: acc,
          callback: (instances: FormListDateEditComponent[], instance: FormListDateEditComponent, oldValue, newValue) => {
            console.log('callback', instances, instance, oldValue, newValue);
            this.onDateTo(instances, instance, oldValue, newValue);
          }
        }
      },
    },
    type: {
      title: 'Price type',
      renderValue: 'test',
      defaultValue: '0',
      editor: {
        type: 'list',
        config: {
          selectText: 'Select',
          list: this.priceTypeOptions,
        },
      },
      filter: false,
      valuePrepareFunction: (cell) => cell > 0 ? UnitData.get(+cell).name : UnitData.get(1).name,
    },
    value: {
      title: 'Price',
      type: 'html',
      filter: false,
    },
    // minValue: {
    //   title: 'Min price',
    //   type: 'html',
    //   defaultValue: '0',
    //   filter: false,
    // },
    currency: {
      title: 'Currency',
      renderValue: 'test',
      defaultValue: Currency.getTableOptions()[0].value,
      editor: {
        type: 'list',
        config: {
          selectText: 'Select',
          list: Currency.getTableOptions(),
        },
      },
      filter: false,
      valuePrepareFunction: (cell) =>
        cell ? this.currencyOptions.find(f => f.value === cell).title : this.currencyOptions[0].title,
    },
    unitSelector: {
      title: 'Unit Selection',
      type: 'custom',
      renderComponent: UnitSelectorRendererComponent,
      filter: false,
      // editor: {
      //   type: 'custom',
      //   component: {ɵcmp: {}},
      // },
      addable: false,
      onComponentInitFunction: (instance: UnitSelectorRendererComponent) => {
        instance.openRequested.subscribe(row => this.openGlobalWindow(row, acc));
      }
    }
  });

  selectedRow = null;
  winAcc = null;
  @ViewChild('globalWindow') globalWindow: NrkWindowComponent;
  openGlobalWindow(row: any, acc: string) {
    this.selectedRow = row;
    this.winAcc = acc;
    if (!this.productPrice.finishedProduct.product?._id) {
      const productId = mongoId(this.productPrice.finishedProduct.product);
      this.productPrice.finishedProduct.product = this.data.baseProducts.find(f => mongoId(f) === productId);
    }
    console.log('openGlobalWindow', this.selectedRow, this.productPrice, this.finishedProduct);
    this.globalWindow.show();
  }
  fpPriceChanged() {
    if (!this.selectedRow) return;

    // Trigger change detection / refresh table
    this.salesTable = [...this.salesTable]; // recreate array to notify ng2-smart-table
    this.api.savePriceMatrix({item: this.productPrice[this.winAcc].matrix, data: this.selectedRow}).then(async item => {
      this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
      this.doUpdateMatrix(this.winAcc);
    });
  }

  matrixFields = [
    // { id: 'business', name: 'Company', editable: false, },
    { id: 'calcName', name: 'Product name', editable: false },
    { id: 'trial', name: 'Trial code', editable: false },
    { id: 'calcCode', name: 'Product code', editable: false },
    { id: 'customers', name: 'Customers', editable: false },
    { id: 'externalName', name: 'Customer product name', editable: false, style: {'max-width':'25rem'} },
    { id: 'externalCode', name: 'Customer product code', editable: false },
    { id: 'currency', name: 'Currency', editable: true, hidden: true, currency: true },
    { id: 'type', name: 'Unit', editable: true, hidden: true, unit: true },
    { id: 'validFrom', name: 'Current price valid from', editable: false, style: {'white-space':'nowrap', 'text-align':'center'} },
    { id: 'validTo', name: 'Current price valid to', editable: true, style: {width: '7rem'} }, //, style: {'white-space':'nowrap', 'text-align':'center'} },
    { id: 'value', name: 'Current price', editable: false, num: true },
    { id: 'latestValid', name: 'Latest valid from', editable: false, style: {'white-space':'nowrap', 'text-align':'center'} },
    { id: 'latestValidTo', name: 'Latest valid to', editable: true, style: {width: '7rem'} }, //, style: {'white-space':'nowrap', 'text-align':'center'} },
    { id: 'latestValue', name: 'Latest price', editable: false, num: true },
    // { id: 'latestMinValue', name: 'Latest min price', editable: false, num: true },
    { id: 'newValue', name: 'New price', editable: true, num: true, style: {width: '5rem'} }, //, popup: true },
    // { id: 'newMinValue', name: 'New min price', editable: true, style: {width: '5rem'} },
    { id: 'newValidFrom', name: 'New valid from date', editable: true, style: {width: '7rem'} },
    { id: 'newValidTo', name: 'New valid to date', editable: true, style: {width: '7rem'} },
    { id: 'files', name: 'Files', editable: true, hidden: true, files: true },
  ];

  sort: { column: string, dir: number } = { column: null, dir: -1 };

  upload = [];

  businessUnitOptions = [{ id: '0', name: 'All' }]; // , ...BusinessUnitAccounting.getOptions()];

  subscriptions: Subscription[] = [];

  readOnly = true;

  canAdd = true;
  canDelete = true;

  constructor(
    private api: ApiService,
    private auth: AuthGuardService,
    private data: SharedDataService,
    private toastrService: NbToastrService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super();
  }

  isReadOnly = (owner: UserModel) => {
    const readOnly = (owner.erpRoles.readOnlyNrka && +this.issuer === IssuerData.get('NRKA').id)
      || (owner.erpRoles.readOnlyNrkg && +this.issuer === IssuerData.get('NRKG').id)
    this.canAdd = !readOnly;
    this.canDelete = !readOnly;
    return readOnly;
  }

  async ngOnInit() {
    this.data.loadBusinesses();
    this.setPriceTypeOptions();
    this.displayMode = this.route.snapshot.params.mode || 'finished-product';
    if (this.route.snapshot.params.issuer) this.issuer = IssuerData.get(this.route.snapshot.params.issuer).id;
    this.auth.loadMe().then(user => {

      this.readOnly = this.isReadOnly(user);

      this.router.events.subscribe(async (ev) => {
        if (ev instanceof NavigationEnd && ev.url.indexOf('/pages/erp/price-matrix') >= 0) {
          this.displayMode = this.route.snapshot.params.mode;
          this.issuer = IssuerData.get(this.route.snapshot.params.issuer).id;
          this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
          if (this.displayMode === 'selling') {
            this.sellingPrice.rowData = this.getRowData(this.sellingPrice);
          } else if (this.displayMode === 'buying') {
            this.buyingPrice.rowData = this.getRowData(this.buyingPrice);
          } else {
            this.updateMatrix();
          }
          this.readOnly = this.isReadOnly(user);
        }
      })
    });

    await this.data.loadProducts();
    this.baseProducts = this.data.baseProducts;
    this.currencyOptions = Currency.getTableOptions();
    this.subscriptions.push(this.api.reloadBusiness({active: true}).subscribe(async _businesses => {
      this.businesses = _businesses;
      this.subscriptions.push(this.api.reloadBusinessUnits().subscribe(bu => {
        this.businessUnitOptions.push(...bu.map(m => ({ id: m._id, name: m.name })));
      }));
      this.finishedProducts = await this.api.loadFinishedProducts();
      this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
      this.businessOptions = this.getBusinessOptions();
      let product = this.route.snapshot.queryParams['finishedProduct'];
      let customers = this.route.snapshot.queryParams['customers'];
      let suppliers = this.route.snapshot.queryParams['suppliers'];
      if (!product) product = mongoId(this.finishedProduct);
      if (!customers) customers = this.finishedProduct && this.finishedProduct.customers.filter(f => f.checked).map(m => m.id);
      if (!suppliers) suppliers = this.finishedProduct && this.finishedProduct.suppliers.filter(f => f.checked).map(m => m.id);

      // eslint-disable-next-line eqeqeq
      this.productPrice.finishedProduct = this.finishedProducts.find(f => f._id == mongoId(product));
      this.setCustomerSupplierOptions(customers, suppliers);

      this.sellingPrice.businessUnit = 0;
      this.buyingPrice.businessUnit = 0;

      this.updateMatrix();

    }));

    this.baseProductOptions = [...new Set(this.baseProducts
      .sort((a, b) => a.name > b.name ? 1 : -1)
      .map(m => ({ id: m.code, name: `${m.code}  |  ${m.trial}  |  ${m.name}` })))];

    // this.finishedProductNames = await this.api.loadFinishedProductNames();
  }

  // async ngOnChanges(changes: SimpleChanges): Promise<void> {
  //   if (changes.finishedProduct && changes.finishedProduct.currentValue) {
  //     console.log('price matrix', this.priceMatrix);
  //     await waitForVariable(this, 'dataLoaded', 5000);
  //     this.displayMode = 'finished-product';
  //     console.log('price matrix2', this.priceMatrix, this.finishedProducts);
  //     const product = mongoId(this.finishedProduct);
  //     const customers = this.finishedProduct.customers;
  //     const suppliers = this.finishedProduct.suppliers;

  //     // eslint-disable-next-line eqeqeq
  //     this.productPrice.finishedProduct = this.finishedProducts.find(f => f._id == mongoId(product));
  //     this.setCustomerSupplierOptions(customers, suppliers);
  //     console.log('sanguis 3', this.productPrice.finishedProduct);

  //     this.sellingPrice.businessUnit = 0;
  //     this.buyingPrice.businessUnit = 0;

  //     this.updateMatrix();
  //   }
  // }
  ngOnChanges(changes: SimpleChanges): void {
    // throw new Error('Method not implemented.');
    // console.log('changes fp', this.finishedProduct);
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  setPriceTypeOptions() {
    // this.priceTypeOptions = [];
    // for (const i in EPriceType) {
    //   if (!isNaN(Number(i))) this.priceTypeOptions.push({ value: i, title: EPriceType[i] });
    // }
    if (this.productPrice.finishedProduct && this.productPrice.finishedProduct.type === EProductType.Electro) {
      this.priceTypeOptions = [ UnitData.getOptions().map(m => ({ value: m.id.toString(), title: m.name }))[0] ];
    } else {
      this.priceTypeOptions = UnitData.getOptions().map(m => ({ value: m.id.toString(), title: m.name }));
    }
    // this.priceColumns.type.editor.config.list = this.priceTypeOptions;
    this.formListSell && this.formListSell.reloadColumns(this.getPriceColumns('sale'));
    this.formListPurchase && this.formListPurchase.reloadColumns(this.getPriceColumns('purchase'));
  }

  getProductName() {
    return this.productPrice.finishedProduct.calcName
      .replace(/ *\(VS\d+\)/, '') + '; ' + this.productPrice.finishedProduct.calcCode;
  }

  getBusinessOptions() {
    return this.businesses
      // .filter(f => Number(f.type) === Number(this.selectedType))
      .map(item => ({ id: item._id, name: item.name }))
      .sort((a, b) => (a.name < b.name) ? -1 : 1);
  }

  setCustomerSupplierOptions(customers, suppliers) {
    this.customerOptions = customers ? this.businesses
      .filter(f => customers.includes(f._id) || this.productPrice.finishedProduct.allCustomers)
      .map(m => ({id: m._id, name: m.name})) : [];
    this.supplierOptions = suppliers ? this.businesses
      .filter(f => suppliers.includes(f._id) || this.productPrice.finishedProduct.allSuppliers)
      .map(m => ({id: m._id, name: m.name})) : [];
    this.productPrice.sale.business = this.customerOptions && this.customerOptions.length &&
      this.customerOptions[0].id;
    this.productPrice.purchase.business = this.supplierOptions && this.supplierOptions.length &&
      this.supplierOptions[0].id;
  }

  findMatrix(businessId: string, finishedProductId: string, sale) {
    return this.priceMatrix.find(
      f => mongoId(f.business) == businessId
        && mongoId(f.finishedProduct) == finishedProductId
        && sale == f.accounting);
  }

  getPrices(mats: Array<any>, idx: number) {
    return mats[idx] && mats[idx].price ? mats[idx].price.map(m => {
      const datem = m.validFrom.match(/([^T]+)/);
      const date = datem ? datem[0] : '';
      const minval = m.minValue ? m.minValue : 0;
      const curr = m.currency ? m.currency : 'EUR';
      return [ date, UnitData.get(m.type).name, minval, curr, m.value ];
    }) : null;
  }

  getDate(): string {
    return new Date().toISOString().match(/([^T]+)/)[0];
  }

  async onSelectFinishedProduct(id: string) {
    const fp = this.productPrice.finishedProduct = this.finishedProducts.find(f => f._id == id);
    this.setCustomerSupplierOptions((fp?.customers || []).map(m => m.id), (fp?.suppliers || []).map(m => m.id));
    this.setPriceTypeOptions();
    this.updateMatrix();
  }

  businessChanged(business, acc) {
    if (acc === this.sellingPrice || acc === this.buyingPrice) {
      acc.rowData = this.getRowData(acc);
    } else {
      this.productPrice[acc].business = mongoId(business);
      this.doUpdateMatrix(acc);
    }
  }

  businessUnitChanged(bu, acc) {
    acc.rowData = this.getRowData(acc);
    console.log('row data', acc.rowData);
  }

  onSort(col) {
    if (col === this.sort.column) {
      this.sort.dir = -this.sort.dir;
    } else {
      this.sort.column = col;
    }
    if (this.displayMode === 'selling') {
      this.sellingPrice.rowData = this.getRowData(this.sellingPrice);
    } else if (this.displayMode === 'buying') {
      this.buyingPrice.rowData = this.getRowData(this.buyingPrice);
    }
  }

  filter(event: Event, field, acc) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
  
    acc.rowData = this.getRowData(acc);
  
    this.currentRows = acc.rowData.filter(row =>
      this.matrixFields.every(col => {
        const input = document.getElementsByName('filter-'+col.id)[0] as HTMLInputElement;
        const value = input?.value?.toLowerCase();
        if (!value) return true;
  
        const cellValue = String(row[col.id] ?? '').toLowerCase();
        return cellValue.includes(value);
      })
    );

  // filter(event, field, acc) {
  //   acc.rowData = this.getRowData(acc);
  //   console.log('filtering');
  //   this.currentRows = acc.rowData.filter(row => {
  //     return this.matrixFields.every(col => {
  //       const input = document.getElementsByName('filter-'+col.id)[0] as HTMLInputElement;
  //       // console.log('*input', input?.value);
  //       if (input?.value) console.log('inpu value', input.value);
  //       const filterValue = input?.value;
  //       if (!filterValue) return true;
  //       const cellValue = String(row[col.id] ?? '').toLowerCase();
  //       if (input && cellValue.includes(filterValue)) {
  //         // console.log('filter', !!input, filterValue, input?.value, cellValue, cellValue.includes(filterValue))
  //       }
  //       return cellValue.includes(filterValue) || !filterValue;
  //     })
  //   });

    // console.log('acc.rowData',event, field, acc)
  //   // TODO: merge
  //   const s = event.target?.value.toLowerCase() ?? event.toLowerCase();
  //   acc.rowData = this.getRowData(acc).filter(f => f[field] && f[field].toLowerCase().includes(s));
  //   console.log('filter', acc.rowData?.length);
  //   const inputs = document.forms['prices'].getElementsByTagName('input');
  //   for (const item of inputs) {
  //     const data = item.name.match(/filter-(.*)/);
  //     if (data) {
  //       const filter = data[1];
  //       // eslint-disable-next-line eqeqeq
  //       if (filter != field) item.value = '';
  //     }
  //   }
  }

  checkKey(char: any) {
    if (char.keyCode < 32) return;
    if (!char.key.match(/[\d\,\.\-]/g)) char.preventDefault();
  }
  checkInput(char: any) {
    char.srcElement.value = char.srcElement.value
      .replace(',', '.')
      .replace(/[.](?=.*[.])/g, '')
  }

  // updateFilter(acc) {
  //   for (let col of this.matrixFields) {
  //     const input = document.getElementsByName(`filter-${col.id}`)[0] as HTMLInputElement;
  //     const value = input?.value;
  //     console.log('update filter', value, col.id, this.accountingPrices);
  //     if (value) this.filter(value, col.id, this.accountingPrices)
  //   }
  //   this.accountingPrices[acc].rowData = this.accountingPrices[acc].rowData.filter(f => this.matrixFields.fi )
  // }

  getRowData(type) {
    if (!type.business) return [];
    let ret = [];
    const codes = [];
    if (this.finishedProducts && this.priceMatrix) this.finishedProducts
      .sort((a, b) => a.code < b.code ? 1 : -1)
      .sort((a, b) => a.version < b.version ? 1: -1)
      .forEach(el => {
        const base = this.baseProducts.find(f => f._id == (el.product && el.product.toString()));
        const businessUnit = base && base.businessUnit;

        // console.log('getRowData', base, businessUnit);

        let pms: PriceItem[] = [];
        this.priceMatrix.filter(f =>
          f.finishedProduct && f.finishedProduct.toString() == el._id
        && (f.business == type.business || !f.business)
        && (f.accounting == type.accounting)
        ).map(m => pms.push(...m.price));
        pms = pms.sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime());

        const latest = pms.length && pms.filter(f => !f.disabled)[0];
        pms =  pms && pms.filter(f => (new Date().getTime() - new Date(f.validFrom).getTime() > 0) && !f.disabled );

        let pmp = pms[0];
        pmp = pmp || new PriceItem();
        const ref =
          type.accounting === EAccountingType.Sale
            ? el.customers && el.customers.map(m => m.id)
            : el.suppliers && el.suppliers.map(m => m.id);

        // console.log('getRowData', type, businessUnit);

        if ((mongoId(type.businessUnit) == mongoId(businessUnit) || +type.businessUnit === 0)
        && ((ref && ref.includes(type.business)) || !type.business || type.business.length == 0)
        ) {
          const product = this.baseProducts.find(f => el.product && f._id == el.product.toString());
          if (!codes.includes(el.code)) {
            codes.push(el.code);
            ret.push({
              id: el._id,
              'calcName': el.calcName.replace(/ *\(VS\d+\)/, ''),
              'trial': product && product.trial,
              'calcCode': el.calcCode,
              'customers': el.customers.map(c => this.data.getBusinessName(c.id)).join(', '),
              'externalName': el.externalName,
              'externalCode': el.externalCode,
              'currency': pmp.currency || Currency.getDefault().code,
              // ? UnitData.get(+pmp.type).short : UnitData.get(1).short,
              'type': pmp.type > 0 ? UnitData.get(+pmp.type).id : UnitData.get(1).id,
              'validFrom': pmp.validFrom && pmp.validFrom.toString().match(/[^T]+/)[0] || '',
              'validTo': pmp.validTo && pmp.validTo.toString().match(/[^T]+/)[0] || '',
              'value': pmp.value,
              'latestValid': latest && latest.validFrom && latest.validFrom.toString().match(/[^T]+/)[0] || '',
              'latestValidTo': latest && latest.validTo && latest.validTo.toString().match(/[^T]+/)[0] || '',
              'latestValue': latest && latest.value || '',
              // 'latestMinValue': latest && latest.minValue || '',
              'newValue': '',
              'newMinValue': '',
              'newValidFrom': '', //new Date().toISOString().match(/[^T]+/)[0],
              'newValidTo': '',
              'files': (this.priceMatrix, this.priceMatrix.find(pm =>
                mongoId(pm.finishedProduct) === mongoId(el)
                && mongoId(pm.business) === mongoId(type.business)
                && pm.accounting === type.accounting
              ) || {})['files'] || [],
              'code': el.code,
              'disabled': (el as FinishedProductModel).disabled,
              'sample': (el as FinishedProductModel).status === EFinishedProductStatus.sample,
              'finishedProduct': { ...el, product: product },
              'priceItem': pmp
            });
          }
        }
      });
    ret = ret.sort((a, b) => {
      let sorta = a[this.sort.column];
      let sortb = b[this.sort.column];
      if ((this.matrixFields.find(f => f.id === this.sort.column) || {})['num']) {
        sorta = +sorta; sortb = +sortb;
      }
      return sorta < sortb ? this.sort.dir : -this.sort.dir;
    });
    // ret = ret.filter(row => {
    //   return this.matrixFields.every(col => {
    //     const input = document.getElementsByName('filter-'+col.id)[0] as HTMLInputElement;
    //     // console.log('*input', input?.value);
    //     const filterValue = input?.value;
    //     const cellValue = String(row[col.id] ?? '').toLowerCase();
    //     if (input) {
    //       console.log('filter', input, filterValue, cellValue, cellValue.includes(filterValue))
    //     }
    //     return cellValue.includes(filterValue) || !filterValue;
    //   })
    // });
    this.currentRows = ret;
    // console.log('filter length',this.currentRows.length)
    return ret;
  }

  updatePrice(row: any, price: PriceItem) {
    row.type = price.type;
    row.value = price.value;
  }

  clearFilter(acc) {
    this.matrixFields.map(m => document.getElementsByName('filter-'+m.id)[0] as HTMLInputElement).forEach(el => {
      el.value = '';
    })
    acc.rowData = this.getRowData(acc);
  }

  saveDocuments(sale: boolean) {
    this.api.updatePriceMatrixFiles(
      this.issuer,
      mongoId(sale ? this.productPrice.sale.business : this.productPrice.purchase.business),
      mongoId(this.productPrice.finishedProduct),
      sale ? 0 : 1,
      sale ? this.productPrice.sale.matrix.files : this.productPrice.purchase.matrix.files,
    );
  }

  saveFiles(row: any) {
    if (this.displayMode === 'selling') {
      this.api.updatePriceMatrixFiles(this.issuer, this.sellingPrice.business, row.id, 0, row.files);
    } else {
      this.api.updatePriceMatrixFiles(this.issuer, this.buyingPrice.business, row.id, 1, row.files);
    }
  }

  // async validateMatrixTable(rows: any, acc: any) {
  //   const errors = [];
  //   const isValidDate = (date: string) => !date || (!isNaN(Date.parse(date)) && /^\d{4}-\d{2}-\d{2}$/.test(date));
  //   // await this.data.loadProducts();
  //   Object.entries(rows).map(([finishedProduct, price]: any[]) => {
  //     const fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(finishedProduct));
  //     // let currentRow = acc.
  //     // let currentPrice = this.currentRows?.find(f => f.calcCode === fp?.calcCode);
  //     let latestPriceItem = this.priceMatrix.find(f => 
  //       mongoId(f.business) === mongoId(acc.business)
  //       && mongoId(f.finishedProduct) === mongoId(fp)
  //       // && f.issuer === acc.issuer
  //       && f.accounting === acc.accounting
  //     )?.price[0];
  //     console.log('checking for validity', acc, latestPriceItem, latestPriceItem.validFrom);
  //     if (!isValidDate(price.newValidFrom)) errors.push(`"New valid from date" for ${fp?.calcCode} is invalid (${price.newValidFrom})`);
  //     if (!isValidDate(price.newValidTo)) errors.push(`"New valid to date" for ${fp?.calcCode} is invalid (${price.newValidTo})`);
  //     if (price.newValue && isNaN(+price.newValue)) errors.push(`"New value" for ${fp?.calcCode} is invalid (${price.newValue})`);
  //     if (isValidDate(price.newValidFrom) && new Date(price.newValidFrom) <= new Date(latestPriceItem.validFrom)) {
  //       errors.push(`${fp?.calcCode}: New date must be greater than "current price valid from" (${latestPriceItem.validFrom} > ${price.newValidFrom})`)
  //     }
  //     if (price.newValidFrom && isValidDate(price.newValidFrom) && !price.newValidTo) errors.push(`${fp?.calcCode}: "New valid to date" is required`);
  //     if (price.newValidFrom && isValidDate(price.newValidFrom) && !price.newValue) errors.push(`${fp?.calcCode}: "New price" is required`);
  //     // if (!price.newValidFrom || !price.newValidTo) errors.push(`${fp?.calcCode}: New valid from/to date is required`);
  //     console.log('the matrix is', this.priceMatrix, latestPriceItem);
  //   });
  //   console.log('errors', errors);
  //   if (errors.length) this.toastrService.danger(errors.join('\n'), 'Validation Error', {duration: 0});
  //   return errors.length ? false : true;
  // }

  async validateMatrixTable(rows: any, acc: any) {
    const errors = [];
    const isValidDate = (date: string) =>
      !date || (!isNaN(Date.parse(date)) && /^\d{4}-\d{2}-\d{2}$/.test(date));

    Object.entries(rows).map(([finishedProduct, price]: any[]) => {
      const fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(finishedProduct));

      const latestPrices = this.priceMatrix.find(f =>
        mongoId(f.business) === mongoId(acc.business) &&
        mongoId(f.finishedProduct) === mongoId(fp) &&
        f.accounting === acc.accounting
      )
      const latestPriceItem = latestPrices?.price[0];

      const { newValue, newValidFrom, newValidTo } = price;

      const anyFilled = newValue || newValidFrom || newValidTo;

      if (anyFilled) {
        if (!newValue)
          errors.push(`${fp?.calcCode}: "New price" is required`);

        if (!newValidFrom)
          errors.push(`${fp?.calcCode}: "New valid from date" is required`);

        if (!newValidTo)
          errors.push(`${fp?.calcCode}: "New valid to date" is required`);
      }

      if (newValidFrom && !isValidDate(newValidFrom))
        errors.push(`"New valid from date" for ${fp?.calcCode} is invalid (${newValidFrom})`);

      if (newValidTo && !isValidDate(newValidTo))
        errors.push(`"New valid to date" for ${fp?.calcCode} is invalid (${newValidTo})`);

      if (newValue && isNaN(+newValue))
        errors.push(`"New value" for ${fp?.calcCode} is invalid (${newValue})`);

      if (
        newValidFrom &&
        isValidDate(newValidFrom) &&
        latestPriceItem &&
        new Date(newValidFrom) <= new Date(latestPriceItem.validFrom)
      ) {
        errors.push(
          `${fp?.calcCode}: New date must be greater than "Latest valid from" (${latestPriceItem.validFrom} > ${newValidFrom})`
        );
      }
    });

    if (errors.length) {
      this.toastrService.danger(errors.join('\n'), 'Validation Error', { duration: 0 });
    }

    return errors.length ? false : true;
  }


  async savePrices(acc: any) {
    const inputs = document.forms['prices'].getElementsByTagName('input');
    const rows = {};
    for (const item of inputs) {
      const data = item.name.match(/cell-(.*)-(.*)/);
      if (data) {
        const id = data[1];
        const field = data[2];
        if (!rows[id]) rows[id] = {};
        rows[id][field] = item.value;
      }
    }
    console.log('save prices rows', rows);
    if (!await this.validateMatrixTable(rows, acc)) return;
    console.log('prices validated');
    const saved = [];
    const promises = [], promises2 = [];
    Object.entries(rows).map(([finishedProduct, price]) => {
      if (price['latestValidTo'] || price['validTo']) {
        let mat = this.findMatrix(acc.business, finishedProduct, acc.accounting);
        let pms = mat.price.sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime());

        const latest = pms.length && pms.filter(f => !f.disabled)[0];
        pms =  pms && pms.filter(f => (new Date().getTime() - new Date(f.validFrom).getTime() > 0) && !f.disabled );
        let current = pms[0];

        if (
          new Date(latest.validTo).getTime() !== new Date(price['latestValidTo']).getTime()
          || new Date(current.validTo).getTime() !== new Date(price['validTo']).getTime()
        ) {
          latest.validTo = new Date(price['latestValidTo']);
          current.validTo = new Date(price['validTo']);
          
          console.log('changing prices', latest, current, mat.price);
          // promises.push(this.api.savePriceMatrix({item: mat, data: undefined}).then(async () => {
          //   this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
          //   const calcCode = this.data.finishedProducts.find(f => mongoId(f) === mongoId(mat.finishedProduct))?.calcCode;
          //   saved.push(`${calcCode}: price sucessfully added`);
          //   console.log('price saved', calcCode, this.priceMatrix);
          //   this.updateMatrix();
          //   acc.rowData = this.getRowData(acc);
          // }));
          promises2.push(this.api.savePrices(this.issuer, acc.business, finishedProduct, acc.accounting, mat.price).then(async () => {
            // this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
            const calcCode = this.data.finishedProducts.find(f => mongoId(f) === mongoId(mat.finishedProduct))?.calcCode;
            saved.push(`${calcCode}: price sucessfully saved`);
            console.log('price saved', calcCode, this.priceMatrix);
            // this.updateMatrix();
            // acc.rowData = this.getRowData(acc);
          }));
        }
      }

      if (price['newValue']) {
        // console.log('save prices price', price);
        let mat = this.findMatrix(acc.business, finishedProduct, acc.accounting);
        if (!mat) {
          mat = new PriceMatrixModel();
          mat.issuer = this.issuer;
          mat.business = acc.business;
          mat.finishedProduct = finishedProduct as unknown as FinishedProductModel;
          mat.accounting = acc.accounting;
          mat.files = acc.files;
        }
        const newData = {
          validFrom: new Date(price['newValidFrom']),
          validTo: new Date(price['newValidTo']),
          // minValue: price['newMinValue'] || 0,
          value: price['newValue'],
          currency: price['currency'],
          type: price['type'], // UnitData.getFromShort(price['type']).id, // this.priceType.indexOf(price['type']),
        }
        console.log('save prices', acc, newData);
        // console.log('save prices newData', newData);
        promises.push(this.api.savePriceMatrix({item: mat, data: newData}).then(async () => {

          // // 1. Find the updated matrix in the freshly loaded collection
          // const updatedMatrix = this.priceMatrix.find(f =>
          //   mongoId(f.business) === mongoId(acc.business) &&
          //   mongoId(f.finishedProduct) === mongoId(mat.finishedProduct) &&
          //   f.accounting === acc.accounting
          // );

          // if (updatedMatrix && updatedMatrix.price?.length > 1) {
          //   const latest = updatedMatrix.price[0];
          //   const previous = updatedMatrix.price[1];

          //   // 2. Compute: previous.validTo = latest.validFrom - 1 day
          //   const newValidTo = new Date(latest.validFrom);
          //   newValidTo.setDate(newValidTo.getDate() - 1);

          //   previous.validTo = newValidTo;

          //   console.log("Updating previous validTo =>", previous.validTo);

          //   // 3. Call your backend "savePrices" endpoint
          //   await this.api.savePrices(
          //     updatedMatrix.issuer,
          //     mongoId(updatedMatrix.business),
          //     mongoId(updatedMatrix.finishedProduct),
          //     updatedMatrix.accounting,
          //     updatedMatrix.price  // entire array (backend replaces it)
          //   );

          //   console.log("Previous price.period updated");
          // }


          // this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
          const calcCode = this.data.finishedProducts.find(f => mongoId(f) === mongoId(mat.finishedProduct))?.calcCode;
          saved.push(`${calcCode}: price sucessfully added`);
          console.log('price saved', calcCode, this.priceMatrix);
          // this.updateMatrix();
          // acc.rowData = this.getRowData(acc);
        }));
      }
    });
    Promise.all(promises).then(async () => {
      Promise.all(promises2).then(async () => {
        this.toastrService.success(saved.join('\n'), 'Matrix saved');
        this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
        this.updateMatrix();
        acc.rowData = this.getRowData(acc);
      })
    })
  }

  disable(event, acc) {
    const mat = this.productPrice[acc].matrix;
    mat.accounting = (acc === 'sale' ? EAccountingType.Sale : EAccountingType.Purchase);
    const price = mat.price.find(f => mongoId(f._id) === mongoId(event.data._id));
    price.disabled = true;
    this.api.savePriceMatrix({item: mat, data: price}).then(() => {
      event.confirm.resolve();
    });
  }

  onDateFrom(instances: FormListDateEditComponent[], instance: FormListDateEditComponent, oldValue, newValue) {
    const acc = instance.cell.getColumn().editor.config.acc;
    const pm: PriceMatrixModel = this.productPrice[acc].matrix;
    const validTo = moment(newValue).subtract(1, 'day').toDate();
    if (acc === 'sale' && this.salesTable?.length) {
      this.salesTable[0].validTo = validTo;
      this.api.savePrices(pm.issuer, mongoId(pm.business), mongoId(pm.finishedProduct), pm.accounting, this.salesTable);
    } else if (acc === 'purchase' && this.purchaseTable?.length){
      this.purchaseTable[0].validTo = validTo;
      this.api.savePrices(pm.issuer, mongoId(pm.business), mongoId(pm.finishedProduct), pm.accounting, this.purchaseTable);
    }
    console.log('callback impl', this.productPrice[acc].matrix, this.salesTable);
    this.doUpdateMatrix(acc);
  }

  onDateTo(instances: FormListDateEditComponent[], instance: FormListDateEditComponent, oldValue, newValue) {
    const dateFrom = instances[instances.indexOf(instance) + 1];
  }

  validate(event, acc) {
    console.log('validate...', event, acc);
    let missing = false;
    let valid = true;
    ['validFrom', 'validTo', 'type', 'value', 'minValue', 'currency'].forEach(field => {
      if (event.newData[field] === null || event.newData[field]?.length === 0) {
        missing = true;
        valid = false;
      } else if (field === 'value' && isNaN(Number(event.newData[field])) /*||
          field === 'minValue' && isNaN(Number(event.newData[field]))*/) {
        this.toastrService.danger('Price: Numeric value is required', 'Validation Error');
        event.confirm.reject('Numeric value >= 0 is required');
        valid = false;
      } else if (field === 'type' && +event.newData[field] < 1) {
        this.toastrService.danger('No price type selected', 'Validation Error');
        event.confirm.reject('No price type selected');
        valid = false;
      }
    });
    if (missing) {
      this.toastrService.danger('All "New" fields are required', 'Validation Error');
      event.confirm.reject('All fields are required');
    }
    // if (Number(event.newData.minValue) > 0 && Number(event.newData.value) < Number(event.newData.minValue) ) {
    //   this.toastrService.danger('Price can\'t be lower than minimum price', 'Validation Error');
    //   event.confirm.reject('Price can\'t be lower than minimum price');
    //   valid = false;
    // }
    if (!this.productPrice[acc].business) {
      this.toastrService.danger(`No ${acc == 'sale' ? 'company' : 'supplier'} selected`, 'Validation Error');
      event.confirm.reject(`No ${acc == 'sale' ? 'company' : 'supplier'} selected`);
      valid = false;
    }
    if (valid) {
      const mats = this.productPrice[acc].matrix;
      mats.accounting = (acc === 'sale' ? EAccountingType.Sale : EAccountingType.Purchase);
      event.newData.validFrom = event.newData.validFrom.replace(/T.*/, '');
      event.newData.validTo = event.newData.validTo.replace(/T.*/, '');
      this.api.savePriceMatrix({item: this.productPrice[acc].matrix, data: event.newData}).then(async item => {
        if (!mats._id) mats._id = item._id;
        this.priceMatrix = await this.api.loadPriceMatrix(this.issuer);
        this.doUpdateMatrix(acc);
      });
      event.confirm.resolve();
    }
  }

  updateMatrix() {
    this.doUpdateMatrix('sale');
    this.doUpdateMatrix('purchase');
  }

  doUpdateMatrix(acc: string) {
    let mats = this.priceMatrix.find(f =>
      mongoId(f.business) === mongoId(this.productPrice[acc].business)
      && mongoId(f.finishedProduct) === mongoId(this.productPrice.finishedProduct)
      && f.accounting === (acc === 'sale' ? EAccountingType.Sale : EAccountingType.Purchase))
    if (!mats) {
      mats = new PriceMatrixModel();
      mats.issuer = this.issuer;
      mats.business = this.productPrice[acc].business;
      mats.finishedProduct = this.productPrice.finishedProduct;
      mats.accounting = acc === 'sale' ? EAccountingType.Sale : EAccountingType.Purchase;
      mats.files = [];
      this.priceMatrix.push(mats);
    }
    this.productPrice[acc].matrix = mats;
    if (acc == 'sale') {
      this.salesTable = mats.price && mats.price.filter(f => !f.disabled);
    } else {
      this.purchaseTable = mats.price && mats.price.filter(f=> !f.disabled);
    }
  }

  navigateToFinishedProduct(id: string) {
    if (this.fromWizard) {
      const fp = this.finishedProducts.find(f => mongoId(f) === mongoId(id));
      this.wizardAction.emit(new WizardAction(EWizardAction.showFinishedProduct, fp));
    } else {
      this.router.navigate(['/pages/erp/finished-product'], { queryParams: { id: id }});
    }
  }

  setFinishedProduct() {
    this.wizardAction.emit(new WizardAction(EWizardAction.finalize,  mongoId(this.productPrice.finishedProduct)));
  }

  baseProductChanged(code: string) {
    this.baseProduct = this.baseProducts.find(bp => bp.code === code)
    this.finishedProductsForComparison = this.finishedProducts.filter(fp => mongoId(fp) === mongoId(this.baseProduct))
  }

  public save(/* item: PriceMatrixModel */) {
  }

  public cancel(/* item: PriceMatrixModel */) {
  }

}
